import React from 'react';
import styled from 'styled-components';
import { Typography } from '@slope/uikit';

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
`;

export interface EmptyStateProps {
  title?: string;
  message?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'Ningún club coincide con tu búsqueda',
  message = 'Intenta ajustar tus criterios de búsqueda',
}) => {
  return (
    <EmptyStateContainer>
      <Typography fontSize="24px" fontWeight="600" color="#95a5a6">
        {title}
      </Typography>
      <Typography fontSize="16px" mt="0.5rem" color="#bdc3c7">
        {message}
      </Typography>
    </EmptyStateContainer>
  );
};
